import React, {useEffect, useState} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {Dropdown} from 'primereact/dropdown';
import {Badge} from 'primereact/badge';
import {Checkbox} from "primereact/checkbox";
import Swal from 'sweetalert2';
import './ServiciosEspeciales.scss'
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import {UpdateValue} from "../../../utilidades/Validaciones";
import {
    getAllies,
    getDrivers,
    getSpecialServices,
    getUnits,
    updateService,
    sendUnitAssignedNotification,
    getLocator
} from "./Integracion";
import {FilterMatchMode} from "primereact/api";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";

const ESTATUS_SERVICIO_ESPECIAL = {
    1: 'Empresarial',
    2: 'Turismo'
};

const ServiciosEspecialesOp = () => {

    const userInfo = useGetDataUser();

    const [dateFilters, setDateFilters] = useState({
        start: {value: new Date(new Date().setDate(new Date().getDate() - 3))},
        end: {value: new Date(new Date().setDate(new Date().getDate() + 1))}
    });

    const [filters, setFilters] = useState({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [services, setServices] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [operadores, setOperadores] = useState([]);
    const [allies, setAllies] = useState([]);
    const [selectedAlly, setSelectedAlly] = useState(null);
    const [isAlly, setIsAlly] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedUnidad, setSelectedUnidad] = useState(null);
    const [selectedOperador, setSelectedOperador] = useState(null);

    const [unitPosition, setUnitPosition] = useState(null);

    const handleUnidadChange = async (unit) => {
        setSelectedUnidad(unit);
        setUnitPosition(null);
        if (!unit) return;

        const currentYear = new Date().getFullYear();
        if (unit.modelo && (currentYear - unit.modelo) > 2) {
            Swal.fire({
                icon: 'warning',
                title: 'Unidad con modelo antiguo',
                html: `La unidad <strong>${unit.name}</strong> es del modelo <strong>${unit.modelo}</strong>.<br>
                   Las unidades con más de 2 años de antigüedad podrían no ser aptas para viajes de Suma Travel.<br><br>
                   <em>¿Deseas continuar de todas formas?</em>`,
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Elegir otra',
                confirmButtonColor: '#EA7831',
                cancelButtonColor: '#9DA5AA',
                customClass: {container: 'swal-over-dialog'},
                didOpen: () => {
                    document.querySelector('.swal-over-dialog').style.zIndex = '9999';
                }
            }).then((result) => {
                if (result.isDismissed) {
                    setSelectedUnidad(null);
                    return;
                }
            });
        }

        try {
            const data = await getLocator(unit.code);
            const u = data?.units?.[0];
            if (u?.x && u?.y) setUnitPosition({
                lat: u.y,
                lng: u.x,
                nombre: u.n,
                ultimoReporte: u.t,
                hace: u.ti,
            });
        } catch {
            setUnitPosition(null);
        }
    };

    const handleOperadorChange = (operador) => {
        setSelectedOperador(operador);
        if (!operador) return;

        const nivelesAlertar = ['C', 'B', 'Sin evaluación'];
        if (nivelesAlertar.includes(operador.nivel)) {
            Swal.fire({
                icon: 'warning',
                title: 'Operador con evaluación baja',
                html: `El operador <strong>${operador.name}</strong> tiene una clasificación de <strong>${operador.nivel}</strong>.<br>
                   Los operadores con nivel C, B o sin evaluación podrían no ser aptos para viajes de Suma Travel.<br><br>
                   <em>¿Deseas continuar de todas formas?</em>`,
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Elegir otro',
                confirmButtonColor: '#EA7831',
                cancelButtonColor: '#9DA5AA'
            }).then((result) => {
                if (result.isDismissed) setSelectedOperador(null);
            });
        }
    };

    const statusColors = {
        'Pendiente': '#EA7831',
        'Asignado': '#15B5DA'
    };

    useEffect(() => {
        getSpecialServices(dateFilters).then(services => setServices(services));
    }, [dateFilters]);

    useEffect(() => {
        getDrivers().then(operadores => setOperadores(operadores));
        getUnits().then(unidades => setUnidades(unidades));
        getAllies().then(allies => setAllies(allies));
    }, []);

    const openAssignDialog = async (service) => {
        setSelectedService(service);
        const unidad = unidades.find(option => option.code === service.UNIDAD);
        setSelectedUnidad(unidad);
        setSelectedOperador(operadores.find(option => option.code === service.ID_OPERADOR));
        setUnitPosition(null);
        setShowDialog(true);

        if (unidad) {
            try {
                const data = await getLocator(unidad.code);
                const u = data?.units?.[0];
                if (u?.x && u?.y) setUnitPosition({
                    lat: u.y,
                    lng: u.x,
                    nombre: u.n,
                    ultimoReporte: u.t,
                    hace: u.ti,
                });
            } catch {
                setUnitPosition(null);
            }
        }
    };

    const saveAssignment = async () => {
        if (!isAlly && selectedUnidad?.modelo) {
            const currentYear = new Date().getFullYear();
            if ((currentYear - selectedUnidad.modelo) > 2) {
                const {isConfirmed} = await Swal.fire({
                    icon: 'warning',
                    title: '¿Confirmar unidad con modelo antiguo?',
                    html: `La unidad <strong>${selectedUnidad.name}</strong> es del modelo <strong>${selectedUnidad.modelo}</strong>. ¿Seguro que deseas asignarla?`,
                    showCancelButton: true,
                    confirmButtonText: 'Sí, asignar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#EA7831',
                    cancelButtonColor: '#9DA5AA'
                });
                if (!isConfirmed) return;
            }
        }

        if (!isAlly && selectedOperador) {
            const nivelesAlertar = ['C', 'B', 'Sin evaluación'];
            if (nivelesAlertar.includes(selectedOperador.nivel)) {
                const {isConfirmed} = await Swal.fire({
                    icon: 'warning',
                    title: '¿Confirmar operador con evaluación baja?',
                    html: `El operador <strong>${selectedOperador.name}</strong> tiene clasificación <strong>${selectedOperador.nivel}</strong>. ¿Seguro que deseas asignarlo?`,
                    showCancelButton: true,
                    confirmButtonText: 'Sí, asignar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#EA7831',
                    cancelButtonColor: '#9DA5AA'
                });
                if (!isConfirmed) return;
            }
        }

        let nuevoEstatus = null;
        if (!isAlly && selectedUnidad && !ESTATUS_SERVICIO_ESPECIAL[Number(selectedUnidad.estatus)]) {
            const {isConfirmed, value} = await Swal.fire({
                icon: 'warning',
                title: 'Cambio de estatus',
                html: `La unidad <strong>${selectedUnidad.name}</strong> no tiene estatus Empresarial ni Turismo.<br>
                   Selecciona el estatus que tendrá al asignarla.`,
                input: 'select',
                inputOptions: ESTATUS_SERVICIO_ESPECIAL,
                inputPlaceholder: 'Selecciona un estatus',
                inputValidator: (value) => !value && 'Debes seleccionar un estatus',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#EA7831',
                cancelButtonColor: '#9DA5AA'
            });
            if (!isConfirmed) return;
            nuevoEstatus = Number(value);
        }

        try {
            let updatedServices = [];

            if (isAlly && selectedAlly) {
                await updateService({
                    unit: null,
                    operador: null,
                    cliente: selectedService.CONTACTO_NOMBRE,
                    prov: selectedAlly.code,
                    provName: selectedAlly.name,
                    phone: selectedService.CONTACTO_TELEFONO,
                    id: selectedService.ID,
                    userId: userInfo?.user?.ID
                });

                updatedServices = services.map(service =>
                    service.ID === selectedService.ID
                        ? {
                            ...service,
                            UNIDAD: null,
                            OPERADOR: null,
                            ID_OPERADOR: null,
                            PROVEEDOR_SERVICIO: selectedAlly.code,
                            ESTADO: 'Asignado'
                        }
                        : service
                );
            } else {
                await updateService({
                    unit: selectedUnidad.code,
                    unitName: selectedUnidad.name,
                    operador: selectedOperador.code,
                    operadorName: selectedOperador.name,
                    cliente: selectedService.CONTACTO_NOMBRE,
                    phone: selectedService.CONTACTO_TELEFONO,
                    prov: null,
                    id: selectedService.ID,
                    userId: userInfo?.user?.ID,
                    estatus: nuevoEstatus
                });

                if (nuevoEstatus !== null) {
                    setUnidades(prev => prev.map(unidad =>
                        unidad.code === selectedUnidad.code ? {...unidad, estatus: nuevoEstatus} : unidad
                    ));
                }

                updatedServices = services.map(service =>
                    service.ID === selectedService.ID
                        ? {
                            ...service,
                            UNIDAD: selectedUnidad.code,
                            OPERADOR: selectedOperador.name,
                            ID_OPERADOR: selectedOperador.code,
                            ESTADO: 'Asignado'
                        }
                        : service
                );
            }

            setServices(updatedServices);
            setShowDialog(false);
            setSelectedService(null);
            setSelectedUnidad(null);
            setSelectedOperador(null);
            setSelectedAlly(null);
            setIsAlly(false);

            // Mensaje de éxito con Swal
            Swal.fire({
                icon: 'success',
                title: '¡Asignación Exitosa!',
                text: 'La unidad/operador ha sido asignado correctamente',
                timer: 2000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Error al actualizar servicio:', error);

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la asignación. Intenta nuevamente.',
                confirmButtonColor: '#15B5DA'
            });
        }
    };

    const closeDialog = () => {
        setShowDialog(false);
        setSelectedService(null);
        setSelectedUnidad(null);
        setSelectedOperador(null);
        setUnitPosition(null);
        setSelectedAlly(null);
        setIsAlly(false);
    };

    /**
     * Handler para enviar notificación
     */
    const handleSendNotification = async (rowData) => {
        try {
            // Validar que tenga asignación
            if (!rowData.ID_OPERADOR && !rowData.PROVEEDOR_SERVICIO) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: 'El servicio debe tener una asignación antes de notificar',
                    confirmButtonColor: '#EA7831'
                });
                return;
            }

            // Confirmar antes de enviar
            const result = await Swal.fire({
                title: '¿Confirmar Asignación?',
                html: `
                    <p>Se enviará una notificación correspondiente al servicio <strong>#${rowData.ID}</strong>.</p>
                    <p>
                        A partir de este momento, <strong>ya no será posible asignar o modificar el operador o proveedor desde este sistema</strong>.
                        Cualquier cambio posterior deberá realizarse exclusivamente por medio de <strong>transferencia</strong>.
                    </p>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#15B5DA',
                cancelButtonColor: '#9DA5AA',
                confirmButtonText: 'Sí, enviar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            // Mostrar loading
            Swal.fire({
                title: 'Confirmando asignación...',
                text: 'Por favor espera',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Preparar datos según el tipo de asignación
            const notificationData = {
                id: rowData.ID,
                cliente: rowData.CONTACTO_NOMBRE,
                phone: rowData.CONTACTO_TELEFONO,
                origen: rowData.LUGAR_ORIGEN,
                destino: rowData.LUGAR_DESTINO,
                fechaServicio: rowData.FECHA_SERVICIO,
                horaServicio: rowData.HORA_SERVICIO
            };

            // Agregar datos de unidad/operador o proveedor
            if (rowData.UNIDAD && rowData.OPERADOR) {
                notificationData.unit = rowData.UNIDAD;
                notificationData.unitName = `UNIDAD-${rowData.UNIDAD}`;
                notificationData.operador = rowData.ID_OPERADOR;
                notificationData.operadorName = rowData.OPERADOR;
            } else if (rowData.PROVEEDOR_SERVICIO) {
                const proveedor = allies.find(ally => ally.code === rowData.PROVEEDOR_SERVICIO);
                notificationData.prov = rowData.PROVEEDOR_SERVICIO;
                notificationData.provName = proveedor?.name || 'Proveedor';
            }

            // Enviar notificación
            await sendUnitAssignedNotification(notificationData);

            // Actualizar el estado local
            const updatedServices = services.map(service =>
                service.ID === rowData.ID
                    ? {...service, NOTIFICADO: true}
                    : service
            );
            setServices(updatedServices);

            // Mostrar mensaje de éxito
            Swal.fire({
                icon: 'success',
                title: '¡Notificación Enviada!',
                text: 'El cliente ha sido notificado correctamente',
                timer: 2500,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Error al enviar notificación:', error);

            Swal.fire({
                icon: 'error',
                title: 'Error al Enviar',
                text: 'No se pudo enviar la notificación. Por favor, intenta nuevamente.',
                confirmButtonColor: '#15B5DA'
            });
        }
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <Badge
                value={rowData.ESTADO}
                style={{
                    backgroundColor: statusColors[rowData.ESTADO],
                    color: 'white',
                    borderRadius: '20px',
                    fontSize: '0.8rem'
                }}
            />
        );
    };

    const notificationBodyTemplate = (rowData) => {
        return (
            <Badge
                value={rowData.NOTIFICADO ? '✔️' : '✖️'}
                style={{
                    backgroundColor: 'transparent',
                    fontSize: '1rem'
                }}
            />
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="pt-0">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Buscar"/>
                </IconField>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        const isAssigned = rowData.ID_OPERADOR || rowData.PROVEEDOR_SERVICIO;
        const isNotified = rowData.NOTIFICADO;

        return (
            <div style={{display: 'flex', gap: '0.5rem'}}>
                <Button
                    label="Asignar"
                    icon="pi pi-user-plus"
                    size="small"
                    onClick={() => openAssignDialog(rowData)}
                    disabled={isNotified}
                    style={{
                        backgroundColor: isNotified ? '#9DA5AA' : '#15B5DA',
                        borderColor: isNotified ? '#9DA5AA' : '#15B5DA',
                        color: 'white',
                        borderRadius: '8px',
                        padding: '0.5rem 1rem'
                    }}
                />

                <Button
                    label={isNotified ? "Confirmado" : "Confirmar"}
                    icon={isNotified ? "pi pi-check" : "pi pi-send"}
                    size="small"
                    severity={isNotified ? "secondary" : "success"}
                    onClick={() => handleSendNotification(rowData)}
                    disabled={!isAssigned || isNotified}
                    style={{
                        borderRadius: '8px',
                        padding: '0.5rem 1rem'
                    }}
                    tooltip={
                        !isAssigned
                            ? 'Primero debes asignar una unidad'
                            : isNotified
                                ? 'Ya se confirmo y se envió la notificación'
                                : 'Confirmar y enviar notificación de unidad asignada'
                    }
                    tooltipOptions={{position: 'top'}}
                />
            </div>
        );
    };

    const shouldDisable = () => {
        if (isAlly) {
            return !selectedAlly;
        }
        return !selectedUnidad || !selectedOperador;
    };

    const assignmentBodyTemplate = (rowData) => {
        if (rowData.UNIDAD && rowData.OPERADOR) {
            return (
                <div style={{fontSize: '0.9rem'}}>
                    <div style={{fontWeight: 'bold', color: '#363E43'}}>
                        UNIDAD-{rowData.UNIDAD}
                    </div>
                    <div style={{color: '#9DA5AA', marginTop: '2px'}}>
                        {rowData.OPERADOR}
                    </div>
                </div>
            );
        } else if (rowData.PROVEEDOR_SERVICIO) {
            const proveedor = allies.find((prov) => prov.code === rowData.PROVEEDOR_SERVICIO);
            return (
                <div style={{fontSize: '0.9rem'}}>
                    <div style={{color: '#9DA5AA', marginTop: '2px'}}>
                        {proveedor?.name || 'Proveedor desconocido'}
                    </div>
                </div>
            );
        }

        return (
            <span style={{color: '#9DA5AA', fontStyle: 'italic'}}>
                Sin asignar
            </span>
        );
    };

    const header = renderHeader();

    const totalServices = services.length;
    const pendingServices = services.filter(s => s.ESTADO === 'Pendiente').length;
    const assignedServices = services.filter(s => s.ESTADO === 'Asignado' || s.ESTADO === 'En Proceso').length;

    return (
        <>
            <div className="p-2">
                <div className="m-2 grid gap-4">
                    <div className="col stat-card">
                        <div className="stat-number">{totalServices}</div>
                        <div className="stat-label">Total Servicios</div>
                    </div>
                    <div className="col stat-card">
                        <div className="stat-number">{pendingServices}</div>
                        <div className="stat-label">Pendientes</div>
                    </div>
                    <div className="col stat-card">
                        <div className="stat-number">{assignedServices}</div>
                        <div className="stat-label">Asignados</div>
                    </div>
                </div>
                <div className='flex flex-row gap-4 mb-3'>
                    <div className="input-date">
                        <InputCalendario readOnlyInput value={dateFilters.start.value} id={"start"}
                                         onChange={(e) => {
                                             UpdateValue(e, "start", dateFilters, setDateFilters)
                                         }} titulo={"Fecha de Inicio"}></InputCalendario>
                    </div>
                    <div className="input-date">
                        <InputCalendario readOnlyInput value={dateFilters.end.value} id={"end"}
                                         onChange={(e) => {
                                             UpdateValue(e, "end", dateFilters, setDateFilters)
                                         }} titulo={"Fecha de Fin"}></InputCalendario>
                    </div>
                </div>

                <div>
                    <DataTable
                        value={services}
                        emptyMessage="No hay servicios disponibles"
                        scrollable
                        scrollHeight="calc(100vh - 315px)"
                        filters={filters}
                        globalFilterFields={['ID', 'LUGAR_ORIGEN', 'LUGAR_DESTINO', 'FECHA_SERVICIO', 'TIPO']}
                        header={header}
                    >
                        <Column field="ID" header="ID" sortable style={{minWidth: '120px'}}/>
                        <Column field="DIRECCION_ORIGEN" header="ORIGEN" sortable style={{minWidth: '200px'}}/>
                        <Column field="DIRECCION_DESTINO" header="DESTINO" sortable style={{minWidth: '200px'}}/>
                        <Column field="FECHA_SERVICIO" header="FECHA" sortable style={{minWidth: '120px'}}/>
                        <Column field="HORA_SERVICIO" header="HORA" sortable style={{minWidth: '100px'}}/>
                        <Column field="FECHA_FINAL" header="FECHA FINAL" sortable style={{minWidth: '120px'}}/>
                        <Column field="HORA_REGRESO" header="HORA REGRESO" sortable style={{minWidth: '100px'}}/>
                        <Column field="PASAJEROS" header="PASAJEROS" sortable
                                style={{minWidth: '100px', textAlign: 'center'}}/>
                        <Column field="TIPO" header="TIPO" sortable
                                style={{minWidth: '100px', textAlign: 'center'}}/>
                        <Column field="ESTADO" header="ESTADO" body={statusBodyTemplate} sortable
                                style={{minWidth: '120px'}}/>
                        <Column header="Asignación" body={assignmentBodyTemplate} style={{minWidth: '150px'}}/>
                        <Column field="NOTIFICADO" header="NOTIFICADO" body={notificationBodyTemplate} sortable
                                style={{minWidth: '120px'}}/>
                        <Column header="Acciones" body={actionBodyTemplate} style={{minWidth: '120px'}}/>
                    </DataTable>
                </div>

                <Dialog
                    header="Asignar Unidad y Operador"
                    visible={showDialog}
                    onHide={closeDialog}
                    style={{width: '800px'}}
                    modal
                    closable
                >
                    <div className="dialog-header">
                        <h3 style={{margin: 0, fontSize: '1.3rem', paddingTop: '0.5rem'}}>
                            <i className="pi pi-ticket" style={{marginRight: '0.5rem'}}></i>
                            Servicio: {selectedService?.ID}
                            <span style={{
                                marginLeft: '1rem',
                                fontSize: '0.9rem',
                                padding: '0.25rem 0.75rem',
                                borderRadius: '12px',
                                backgroundColor: selectedService?.ESTADO === 'Pendiente' ? '#fff3cd' : '#d1ecf1',
                                color: selectedService?.ESTADO === 'Pendiente' ? '#856404' : '#0c5460'
                            }}>
                                {selectedService?.ESTADO}
                            </span>
                        </h3>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '1rem',
                        padding: '1rem',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        marginBottom: '1rem'
                    }}>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-car" style={{marginRight: '0.5rem'}}></i>
                                Tipo de Unidad:
                            </strong>
                            <p style={{
                                margin: '0.5rem 0 0 0',
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                color: '#007bff'
                            }}>
                                {selectedService?.TIPO}
                            </p>
                        </div>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-users" style={{marginRight: '0.5rem'}}></i>
                                Pasajeros:
                            </strong>
                            <p style={{
                                margin: '0.5rem 0 0 0',
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                color: '#007bff'
                            }}>
                                {selectedService?.PASAJEROS}
                            </p>
                        </div>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '1rem',
                        marginBottom: '1rem',
                        padding: '1rem',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px'
                    }}>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-calendar" style={{marginRight: '0.5rem'}}></i>
                                Fecha de Inicio:
                            </strong>
                            <p style={{margin: '0.25rem 0 0 0'}}>{selectedService?.FECHA_SERVICIO}</p>
                        </div>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-calendar-times" style={{marginRight: '0.5rem'}}></i>
                                Fecha Final:
                            </strong>
                            <p style={{margin: '0.25rem 0 0 0'}}>{selectedService?.FECHA_FINAL}</p>
                        </div>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-clock" style={{marginRight: '0.5rem'}}></i>
                                Hora de Salida:
                            </strong>
                            <p style={{margin: '0.25rem 0 0 0'}}>{selectedService?.HORA_SERVICIO}</p>
                        </div>
                        <div>
                            <strong style={{color: '#495057'}}>
                                <i className="pi pi-clock" style={{marginRight: '0.5rem'}}></i>
                                Hora de Regreso:
                            </strong>
                            <p style={{margin: '0.25rem 0 0 0'}}>{selectedService?.HORA_REGRESO}</p>
                        </div>
                    </div>

                    <div style={{marginBottom: '1rem'}}>
                        <h4 style={{
                            margin: '0 0 0.5rem 0',
                            color: '#28a745',
                            fontSize: '1rem',
                            borderBottom: '2px solid #28a745',
                            paddingBottom: '0.5rem'
                        }}>
                            <i className="pi pi-map-marker" style={{marginRight: '0.5rem'}}></i>
                            Origen
                        </h4>
                        {selectedService?.LUGAR_ORIGEN && (
                            <p style={{margin: '0.5rem 0'}}>
                                <strong>Lugar:</strong> {selectedService.LUGAR_ORIGEN}
                            </p>
                        )}
                        {selectedService?.DIRECCION_ORIGEN && (
                            <p style={{margin: '0.5rem 0', color: '#6c757d'}}>
                                <i className="pi pi-home" style={{marginRight: '0.5rem'}}></i>
                                {selectedService.DIRECCION_ORIGEN.trim()}
                            </p>
                        )}
                        {selectedService?.NOTA_ORIGEN && (
                            <p style={{
                                margin: '0.5rem 0',
                                padding: '0.5rem',
                                backgroundColor: '#e7f3ff',
                                borderLeft: '3px solid #007bff',
                                fontStyle: 'italic'
                            }}>
                                {selectedService.NOTA_ORIGEN}
                            </p>
                        )}
                    </div>

                    <div style={{marginBottom: '1rem'}}>
                        <h4 style={{
                            margin: '0 0 0.5rem 0',
                            color: '#dc3545',
                            fontSize: '1rem',
                            borderBottom: '2px solid #dc3545',
                            paddingBottom: '0.5rem'
                        }}>
                            <i className="pi pi-flag" style={{marginRight: '0.5rem'}}></i>
                            Destino
                        </h4>
                        {selectedService?.LUGAR_DESTINO && (
                            <p style={{margin: '0.5rem 0'}}>
                                <strong>Lugar:</strong> {selectedService.LUGAR_DESTINO}
                            </p>
                        )}
                        {selectedService?.DIRECCION_DESTINO && (
                            <p style={{margin: '0.5rem 0', color: '#6c757d'}}>
                                <i className="pi pi-home" style={{marginRight: '0.5rem'}}></i>
                                {selectedService.DIRECCION_DESTINO.trim()}
                            </p>
                        )}
                        {selectedService?.NOTA_DESTINO && (
                            <p style={{
                                margin: '0.5rem 0',
                                padding: '0.5rem',
                                backgroundColor: '#fff3cd',
                                borderLeft: '3px solid #ffc107',
                                fontStyle: 'italic',
                                whiteSpace: 'pre-line'
                            }}>
                                {selectedService.NOTA_DESTINO}
                            </p>
                        )}
                    </div>

                    {selectedService?.NOTA_SERVICIO && (
                        <div style={{marginBottom: '1.5rem'}}>
                            <span className="form-label">
                                <i className="pi pi-clipboard" style={{marginRight: '0.5rem'}}></i>
                                Notas del Servicio
                            </span>
                            <p style={{
                                margin: '0.5rem 0',
                                padding: '0.75rem',
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #dee2e6',
                                borderRadius: '6px',
                                whiteSpace: 'pre-line'
                            }}>
                                {selectedService.NOTA_SERVICIO}
                            </p>
                        </div>
                    )}

                    <hr style={{margin: '1.5rem 0', border: 'none', borderTop: '2px solid #dee2e6'}}/>

                    <div className="custom-checkbox-container">
                        <Checkbox
                            inputId="ally"
                            onChange={e => setIsAlly(e.checked)}
                            checked={isAlly}
                            className="custom-checkbox"
                        />
                        <label htmlFor="ally" className="custom-label">Es aliado</label>
                    </div>

                    {!isAlly ? (
                        <>
                            <div className="form-group mb-3">
                                <label className="form-label">
                                    <i className="pi pi-truck" style={{marginRight: '0.5rem'}}/>
                                    Seleccionar Unidad
                                </label>
                                <Dropdown
                                    className="dropdown-special-service"
                                    value={selectedUnidad}
                                    options={unidades}
                                    optionLabel="name"
                                    onChange={(e) => handleUnidadChange(e.value)}
                                    placeholder="Selecciona una unidad"
                                    filter
                                    filterBy="code,name"
                                />

                                {unitPosition && (
                                    <div className="flex align-items-center justify-content-between mt-2 p-2"
                                         style={{
                                             background: '#f8f9fa',
                                             borderRadius: '6px',
                                             border: '1px solid #dee2e6'
                                         }}>
                                        <div className="flex flex-column gap-1">
                                            <div className="flex align-items-center gap-1">
                                                <i className="pi pi-map-marker"
                                                   style={{fontSize: '0.8rem', color: '#15B5DA'}}/>
                                                <span style={{
                                                    fontSize: '0.8rem',
                                                    fontWeight: 600
                                                }}>{unitPosition.nombre}</span>
                                            </div>
                                            <div className="flex align-items-center gap-1">
                                                <i className="pi pi-clock"
                                                   style={{fontSize: '0.75rem', color: '#9DA5AA'}}/>
                                                <span style={{
                                                    fontSize: '0.75rem',
                                                    color: '#9DA5AA'
                                                }}>{unitPosition.hace}</span>
                                            </div>
                                        </div>
                                        <Button
                                            label="Ver en mapa"
                                            icon="pi pi-map"
                                            size="small"
                                            text
                                            onClick={() => window.open(`https://www.google.com/maps?q=${unitPosition.lat},${unitPosition.lng}`, '_blank')}
                                            style={{fontSize: '0.78rem'}}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label">
                                    <i className="pi pi-user" style={{marginRight: '0.5rem'}}/>
                                    Seleccionar Operador
                                </label>
                                <Dropdown
                                    className="dropdown-special-service"
                                    value={selectedOperador}
                                    options={operadores}
                                    optionLabel="name"
                                    onChange={(e) => handleOperadorChange(e.value)}
                                    placeholder="Selecciona un operador"
                                    filter
                                    filterBy="code,name"
                                />
                            </div>
                        </>
                    ) : (
                        <div className="form-group">
                            <label className="form-label">
                                <i className="pi pi-truck" style={{marginRight: '0.5rem'}}></i>
                                Selecciona un aliado
                            </label>
                            <Dropdown
                                className="dropdown-special-service"
                                value={selectedAlly}
                                options={allies}
                                optionLabel="name"
                                onChange={(e) => setSelectedAlly(e.value)}
                                placeholder="Selecciona un aliado"
                                filter
                                filterBy="code,name"
                            />
                        </div>
                    )}

                    <div className="dialog-actions">
                        <Button
                            label="Cancelar"
                            onClick={closeDialog}
                            className="btn-cancel"
                        />
                        <Button
                            label="Guardar Asignación"
                            onClick={saveAssignment}
                            disabled={shouldDisable()}
                            className="btn-save"
                        />
                    </div>
                </Dialog>
            </div>
        </>
    );
};

export default ServiciosEspecialesOp;
